(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const followLegacyLink = () => {
      const key = location.hash.slice(1);
      const legacyThemes = {"dogs": "/products/custom-dog-signs-metal-art", "fishing": "/products/custom-hunting-fishing-cabin-outdoor-metal-signs-metal-art", "coastal": "/products/custom-marine-nautical-coastal-metal-signs-metal-art", "service": "/products/custom-military-police-fire-metal-signs-metal-art", "trades": "/products/custom-construction-trade-metal-signs-displays", "cannabis": "/products/custom-420-metal-signs-wall-art", "automotive": "/products/custom-automotive-metal-signs-garage-metal-art", "farm": "/products/custom-farm-country-metal-signs-metal-art", "sports": "/products/custom-sports-metal-signs-metal-art", "maryland": "/products/custom-maryland-chesapeake-bay-metal-signs-metal-art", "restaurant": "/products/custom-restaurant-bar-retail-metal-signs-displays", "gym": "/products/custom-gym-fitness-metal-signs-displays"};
      if (legacyThemes[key]) location.replace(legacyThemes[key]);
    };
    root.querySelector('.ems__browse')?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      history.replaceState(null, '', '#custom-examples');
      root.querySelector('#custom-examples').scrollIntoView({block:'start', behavior:'instant'});
    });
    followLegacyLink();
    window.addEventListener('hashchange', followLegacyLink);
  };
  document.querySelectorAll('[data-signs-studio]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-signs-studio]').forEach(init));
})();
